export default "__VITE_ASSET__CHoCOHjL__"